import Cookies from 'universal-cookie'
const cookies = new Cookies()

export const PlatformAdminUI = () => {
  try { initPlatformAdminUI() } catch (e) { /* just don't crash old browsers */ }
}

const initPlatformAdminUI = () => {
  document.querySelectorAll('[data-behavior~="platform-admin-quickinfo"]').forEach(quickinfo => {
    initQuickinfo(quickinfo)
  })

  document.querySelectorAll('[data-behavior="highlight-labels-for-testing"]').forEach(highlighter => {
    initLabelHighlighter(highlighter)
  })

  cookies.get('betterplace_backoffice_user_signed_in') && initAdminBoxes()
}

const initQuickinfo = (quickinfo) => {
  const collapse = () => quickinfo.classList.toggle('collapsed')

  if (window.innerWidth <= 420) collapse()

  quickinfo.querySelectorAll('[data-behavior="collapse-admin-boxes"]').forEach(toggler => {
    toggler.addEventListener('click', event => {
      event.preventDefault()
      collapse()
    })
  })

  quickinfo.querySelectorAll('[data-behavior="close-admin-boxes"]').forEach(closer => {
    closer.addEventListener('click', event => {
      event.preventDefault()
      document.querySelectorAll('.generic-admin-box.for-platform-admins').forEach(adminBox => {
        adminBox.style.display = 'none'
      })
    })
  })
}

const initLabelHighlighter = (highlighter) => {
  highlighter.addEventListener('click', () => {
    document.querySelectorAll('label').forEach(label => {
      label.classList.toggle('highlight-labels-for-testing')
    })
    highlighter.classList.toggle('active')
  })
}

const initAdminBoxes = () => {
  document.querySelectorAll('[data-permission="admin"]').forEach(box => {
    box.style.display = '' // un-hide
    box.dataset.source && fetch(box.dataset.source).then(res => res.ok && res.text()).then(text => {
      box.innerHTML = text
      box.querySelectorAll('[data-behavior~="platform-admin-quickinfo"]').forEach(quickinfo => {
        initQuickinfo(quickinfo)
      })
    })
  })
}
